// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import Link from "@insite/mobius/Icons/Link";
import { dealerInformationStyles } from "@steiner/Overrides/Widgets/DealerDetails/DealerInformation";
import ChevronLeft from "@steiner/XDL/Icons/ChevronLeft";
import { fontConfig } from "@steiner/XDL/PreStyle/typography";
import { color } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

dealerInformationStyles.selectedDealerDisplayBackToResultsLink = {
    icon: {
        iconProps: {
            src: ChevronLeft,
            size: 12,
        },
        position: "left",
    },
    typographyProps: {
        size: 14,
    },
};

dealerInformationStyles.nameText = {
    variant: "h2",
    forwardAs: "h1",
    color: "common.ui6",
    weight: fontConfig.weight.regular,
    ellipsis: true,
    css: css`
        margin-bottom: 0;
        padding-bottom: 4px;
        border-bottom: 1px solid ${color("common.border")};
        flex: 1;
    `,
};
dealerInformationStyles.htmlContentGridItem = {
    width: 12,
    css: css`
        padding-top: 20px;
        flex-direction: column;
    `,
};
dealerInformationStyles.nameGridItem = {
    width: 12,
};
dealerInformationStyles.phoneLink = {};
dealerInformationStyles.phoneGridItem = {
    width: 12,
    css: css`
        padding-top: 0;
    `,
};

dealerInformationStyles.addressInfoCondensed = {
    wrapper: {
        css: css`
            font-style: normal;
        `,
    },
};
dealerInformationStyles.googleMapsDirectionLink = {
    icon: {
        iconProps: {
            src: Link,
            size: 14,
            css: css`
                margin-right: 4px;
            `,
        },
        position: "left",
    },
    typographyProps: {
        css: css`
            font-size: 14px;
            line-height: 22px;
        `,
    },
};

dealerInformationStyles.googleMapsDirectionLinkGridItem = {
    width: 12,
};
dealerInformationStyles.dealerInformationSubTitle = {
    variant: "h6",
    color: "common.ui6",
    css: css`
        border-bottom: 1px solid ${color("common.border")};
    `,
};

dealerInformationStyles.visitWebsiteLink = {
    icon: {
        iconProps: {
            src: Link,
            size: 14,
            css: css`
                margin-right: 4px;
            `,
        },
        position: "left",
    },
    typographyProps: {
        css: css`
            font-size: 14px;
            line-height: 22px;
        `,
    },
};
